export class EmailTemplate {
  key = "";
  description = "";
  kind = "";

  constructor(params: Partial<EmailTemplate> = {}) {
    Object.assign(this, params);
  }
}

export class EmailTemplateCustomization {
  key = "";
  category = "";
  description = "";
  default = "";
  data_type = "";
  value = "";
  label = "";
  options = "";

  constructor(params: Partial<EmailTemplateCustomizationResponse> = {}) {
    const newParams = { ...params };
    if (newParams.value === null) newParams.value = newParams.default || "";
    if (newParams.default === null) newParams.default = "";
    Object.assign(this, newParams);
  }

  getData() {
    return {
      ...this,
      value: this.isDefaultValue ? null : this.value
    };
  }

  get isDefaultValue() {
    return (
      this.value === this.default ||
      this.value === `<span>${this.default}</span>`
    );
  }
}

export type EmailTemplateCustomizationResponse = EmailTemplateCustomization & {
  value: null | string;
  default: null | string;
};
